import { useState } from 'react';
import Paragraph from '../typography/Paragraph';
import { useContactMutation } from '@/features/contact/hooks';

interface ContactDetail {
  icon: React.ReactNode;
  text: string;
}

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [errors, setErrors] = useState<Record<string, string>>({});
  const contactMutation = useContactMutation();

  const contactDetails: ContactDetail[] = [
    {
      icon: (
        <svg
          className="w-4 h-4 md:w-8 md:h-8"
          width="26"
          height="20"
          viewBox="0 0 26 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.74432 20C2.07076 20 1.50065 19.7667 1.03398 19.3C0.567318 18.8333 0.333984 18.2632 0.333984 17.5897V2.41033C0.333984 1.73678 0.567318 1.16667 1.03398 0.7C1.50065 0.233333 2.07076 0 2.74432 0H23.257C23.9305 0 24.5007 0.233333 24.9673 0.7C25.434 1.16667 25.6673 1.73678 25.6673 2.41033V17.5897C25.6673 18.2632 25.434 18.8333 24.9673 19.3C24.5007 19.7667 23.9305 20 23.257 20H2.74432ZM13.0007 10.7437L2.33398 3.923V17.5897C2.33398 17.7094 2.37243 17.8078 2.44932 17.8847C2.52621 17.9616 2.62454 18 2.74432 18H23.257C23.3768 18 23.4751 17.9616 23.552 17.8847C23.6289 17.8078 23.6673 17.7094 23.6673 17.5897V3.923L13.0007 10.7437ZM13.0007 8.66667L23.4623 2H2.53898L13.0007 8.66667ZM2.33398 3.923V2V17.5897C2.33398 17.7094 2.37243 17.8078 2.44932 17.8847C2.52621 17.9616 2.62454 18 2.74432 18H2.33398V3.923Z"
            fill="#141414"
          />
        </svg>
      ),
      text: 'contact@soberhub.com',
    },
    {
      icon: (
        <svg
         className="w-4 h-4 md:w-8 md:h-8"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.9197 23.3337C19.407 23.3337 16.8827 22.7494 14.3467 21.581C11.8109 20.4125 9.48102 18.7643 7.35702 16.6363C5.23324 14.5081 3.58713 12.1781 2.41868 9.64633C1.25024 7.11477 0.666016 4.59266 0.666016 2.07999C0.666016 1.67621 0.799349 1.33977 1.06602 1.07066C1.33268 0.801547 1.66602 0.666992 2.06602 0.666992H6.41468C6.75135 0.666992 7.04835 0.776882 7.30568 0.996659C7.56302 1.21621 7.72668 1.48755 7.79668 1.81066L8.56102 5.73366C8.6139 6.09766 8.60279 6.41044 8.52768 6.67199C8.45235 6.93355 8.31724 7.15321 8.12235 7.33099L5.04302 10.3287C5.53857 11.2362 6.10479 12.0948 6.74168 12.9043C7.37835 13.7137 8.06768 14.4867 8.80968 15.2233C9.54124 15.9551 10.319 16.6347 11.143 17.262C11.967 17.8893 12.8568 18.4731 13.8123 19.0133L16.8043 15.9953C17.013 15.7782 17.2657 15.626 17.5623 15.5387C17.8588 15.4515 18.1669 15.4302 18.4867 15.4747L22.189 16.2287C22.5257 16.3175 22.8005 16.4893 23.0133 16.744C23.2262 16.9987 23.3327 17.2875 23.3327 17.6107V21.9337C23.3327 22.3337 23.1981 22.667 22.929 22.9337C22.6599 23.2003 22.3235 23.3337 21.9197 23.3337ZM4.09668 8.43633L6.47635 6.15933C6.51902 6.1251 6.54679 6.0781 6.55968 6.01832C6.57257 5.95855 6.57046 5.90299 6.55335 5.85166L5.97368 2.87199C5.95657 2.80377 5.92668 2.75255 5.88402 2.71832C5.84135 2.6841 5.78579 2.66699 5.71735 2.66699H2.86602C2.81468 2.66699 2.7719 2.6841 2.73768 2.71832C2.70368 2.75255 2.68668 2.79533 2.68668 2.84666C2.7549 3.75777 2.90402 4.68333 3.13402 5.62333C3.36379 6.56355 3.68468 7.50121 4.09668 8.43633ZM15.6967 19.9593C16.5805 20.3713 17.5022 20.6863 18.462 20.9043C19.422 21.1221 20.319 21.2515 21.153 21.2927C21.2043 21.2927 21.2471 21.2755 21.2813 21.2413C21.3156 21.2071 21.3327 21.1643 21.3327 21.113V18.308C21.3327 18.2395 21.3156 18.184 21.2813 18.1413C21.2471 18.0987 21.1959 18.0688 21.1277 18.0517L18.3277 17.4823C18.2763 17.4652 18.2315 17.4631 18.193 17.476C18.1546 17.4889 18.1139 17.5167 18.071 17.5593L15.6967 19.9593Z"
            fill="#141414"
          />
        </svg>
      ),
      text: '+92 300 1234567',
    },
    {
      icon: (
        <svg
         className="w-4 h-4 md:w-8 md:h-8"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9993 23.2818L7.99935 20.4818L2.26102 22.7021C1.8679 22.8543 1.50379 22.8108 1.16868 22.5714C0.833571 22.3321 0.666016 22.0048 0.666016 21.5894V4.10244C0.666016 3.83911 0.736571 3.60277 0.877682 3.39344C1.01857 3.18411 1.21646 3.03244 1.47135 2.93844L7.99935 0.717773L15.9993 3.51777L21.7377 1.29744C22.1308 1.14522 22.4949 1.18233 22.83 1.40877C23.1651 1.63522 23.3327 1.95189 23.3327 2.35877V19.9484C23.3327 20.2202 23.2558 20.4587 23.102 20.6638C22.948 20.8689 22.7395 21.0184 22.4763 21.1124L15.9993 23.2818ZM14.9993 20.8358V5.23577L8.99935 3.13811V18.7381L14.9993 20.8358ZM16.9993 20.8358L21.3327 19.3998V3.59977L16.9993 5.23577V20.8358ZM2.66602 20.3998L6.99935 18.7381V3.13811L2.66602 4.59977V20.3998Z"
            fill="#141414"
          />
        </svg>
      ),
      text: '120 Main St, Springfield',
    },
  ];

  // Validate form
  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!formData.name.trim() || formData.name.length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = 'Please provide a valid email address';
    }

    if (!formData.subject.trim() || formData.subject.length < 5) {
      newErrors.subject = 'Subject must be at least 5 characters';
    }

    if (!formData.message.trim() || formData.message.length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle input change
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error for this field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    contactMutation.mutate(formData, {
      onSuccess: () => {
        // Clear form on success
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
        });
        setErrors({});
      },
    });
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="name" className="block text-primary mb-3">
              Fullname
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Smith"
              className={`w-full border-[1px] rounded-xl px-4 py-3 text-base md:text-xl ${
                errors.name ? 'border-red-500' : 'border-[#BFBFBF]'
              }`}
              id="name"
            />
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
            )}
          </div>
          <div className="mb-6">
            <label htmlFor="email" className="block text-primary mb-3">
              Email address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className={`w-full border-[1px] rounded-xl px-4 py-3 text-base md:text-xl ${
                errors.email ? 'border-red-500' : 'border-[#BFBFBF]'
              }`}
              id="email"
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>
          <div className="mb-6">
            <label htmlFor="subject" className="block text-primary mb-3">
              Subject
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="General inquiry"
              className={`w-full border-[1px] rounded-xl px-4 py-3 text-base md:text-xl ${
                errors.subject ? 'border-red-500' : 'border-[#BFBFBF]'
              }`}
              id="subject"
            />
            {errors.subject && (
              <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
            )}
          </div>
          <div className="mb-6">
            <label htmlFor="message" className="block text-primary mb-3">
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your message here..."
              className={`h-50 w-full border-[1px] rounded-xl px-4 py-3 text-base md:text-xl ${
                errors.message ? 'border-red-500' : 'border-[#BFBFBF]'
              }`}
              id="message"
              rows={5}
            />
            {errors.message && (
              <p className="text-red-500 text-sm mt-1">{errors.message}</p>
            )}
          </div>

          <div>
            <button
              type="submit"
              disabled={contactMutation.isPending}
              className={`text-base md:text-lg text-white font-bold px-6 py-3 rounded-lg transition-colors ${
                contactMutation.isPending
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#5761EB] hover:bg-[#4651DB]'
              }`}
            >
              {contactMutation.isPending ? 'Sending...' : 'Send message'}
            </button>
          </div>
        </form>

        <div>
          <Paragraph className="font-bold text-primary mb-4 md:mb-8">
            Contact details
          </Paragraph>

          {contactDetails.map((item, i) => (
            <div className="flex items-center gap-3 mb-4 md:mb-6" key={i}>
              <div className="p-2 md:p-4 rounded-full border border-[#BFBFBF]">
                {item.icon}
              </div>
              <Paragraph className="!text-primary">{item.text}</Paragraph>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ContactForm;
